import { MachinesMainGridController as BaseController, dependencies as ParentControllerDependencies } from '../../../../common/Pages/Main/Grid/controller'
import { MachinesMainGridConfig } from '../../../../common/Pages/Main/Grid/config'

import { vsName as CommonMachineServerName } from '../../../../common/Server'
import DesertDiamondMachineServer from '../../../Server'

import template from './index.html'
import { get } from 'lodash'

const controllerDependencies = [...ParentControllerDependencies]
controllerDependencies.splice(controllerDependencies.indexOf(CommonMachineServerName), 1, DesertDiamondMachineServer.vsName)

class MachinesMainGridController
  extends BaseController {
  constructor() {
    super(...arguments)

    this.selectedProperties = []

    this.serverUtility.fetchAll({
      url: "/api/properties",
      query: { OrderBy: "Name"}
    })
    .then(properties => {
      this.properties = properties
      const currentPropertyIds = this.query.PropertyIds || []
      currentPropertyIds.forEach(propertyId => {
        const matchedProperty = this.properties.find(p => p.Id === propertyId)
        if (matchedProperty) {
          this.selectedProperties.push(matchedProperty)
        }
      })
    })
    // this.PropertyServer.getAllProperties().then(properties => {
    //   this.properties = properties
    //   const currentPropertyIds = this.query.PropertyIds || []
    //   currentPropertyIds.forEach(propertyId => {
    //     const matchedProperty = this.properties.find(p => p.Id === propertyId)
    //     if (matchedProperty) {
    //       this.selectedProperties.push(matchedProperty)
    //     }
    //   })
    // })
  }

  getUserPropertyIds() {
    return get(this, 'userProfile.PropertyIds', [])
  }

  getColumnDefs() {
    let columnDefs = super.getColumnDefs()

    if (this.getUserPropertyIds().length > 1) {
      columnDefs.splice(2, 0, { headerName: 'Property', field: 'PropertyName', editable: false, suppressMenu: true })
    }

    return columnDefs
  }

  clearFilters() {
    super.clearFilters()
    this.selectedProperties = []
  }

  propertySelectionChanged() {
    const properties = this.selectedProperties
    const propertyIds = properties.map(p => p.Id)
    this.query.PropertyIds = propertyIds
    this.filterChanged()
  }
}
MachinesMainGridController.$inject = controllerDependencies

export default function machinesMainGridControllerConfig() {
  MachinesMainGridConfig.GridController = MachinesMainGridController
  MachinesMainGridConfig.templateUrl = template
}
machinesMainGridControllerConfig.vsNgType = 'config'
machinesMainGridControllerConfig.vsName = 'machinesMainGridControllerConfig'
